import { Link } from "react-router-dom";

import { cn } from "@/lib/utils";
import { SITE_NAME } from "@/data/site";

interface LogoProps {
  className?: string;
  variant?: "default" | "footer";
  testId?: string;
}

// Brand colors sampled from the official MedCore Research logo.
const NAVY = "#16356B";
const GREEN = "#57B11E";

/**
 * Official MedCore Research logo lockup: the bridge "M" mark (image) paired
 * with the brand wordmark. Swap /public/medcore-icon.png to update the mark.
 */
export function Logo({ className, testId }: LogoProps) {
  return (
    <Link
      to="/"
      aria-label={`${SITE_NAME} home`}
      data-testid={testId}
      className={cn("group inline-flex items-center gap-2.5", className)}
    >
      <img
        src={`${process.env.PUBLIC_URL}/medcore-icon.png`}
        alt="MedCore Research"
        className="h-9 w-auto shrink-0 transition-transform duration-200 group-hover:-translate-y-0.5 sm:h-10"
      />
      <span className="flex flex-col leading-none">
        <span className="font-heading text-lg font-bold tracking-tight leading-none">
          <span style={{ color: NAVY }}>Med</span>
          <span style={{ color: GREEN }}>Core</span>
        </span>
        <span
          className="mt-1 text-[10px] font-semibold uppercase tracking-[0.3em]"
          style={{ color: NAVY, opacity: 0.85 }}
        >
          Research
        </span>
      </span>
    </Link>
  );
}
